<template>
  <div>
    <div class="col-md-12">
      <!-- Header Section -->
      <div class="mb-1">
        <b-col class="row alert" p-2 col-md-12 style="margin-left: 0">
          <h3 style="color: #345B48;" class="col-12 p-0">
            {{ slider && slider !== 100 ? $t("header_partial_option") : $t("header_full_purchase") }}
          </h3>
          <div class="col-12 p-0">
            <h6 class="mb-3 font-medium-4" v-if="slider && slider !== 100">
              <span style="font-size: 17px; color: rgb(34 47 40 / 60%); font-style: italic">
                {{ $t("subline_partial_option") }}
              </span>
              <feather-icon id="tooltipOvertake" icon="AlertTriangleIcon" size="20" />
              <b-tooltip target="tooltipOvertake" placement="top" custom-class="custom-tooltip">
                {{ $t("tooltip_overtake_cancellation") }}
              </b-tooltip>
            </h6>
            <h6 v-else class="mb-3 font-medium-4">
              <span style="font-size: 18px; color: rgb(34 47 40 / 60%); font-style: italic">
                {{ $t("subline_full_purchase") }}
              </span>
            </h6>
          </div>
        </b-col>
      </div>

      <!-- Invoice Details Section -->
      <b-row v-for="(item, index) in invoiceData" :key="index" class="mb-1 mt-1">
        <b-col xl="3" lg="3" md="4">
          <h4 class="font-weight-bolder">{{ $t(item.text) }}</h4>
        </b-col>
        <b-col>
          <h4>{{ item.value }}</h4>
        </b-col>
      </b-row>

      <!-- Optional Share of Invoice -->
      <b-row v-if="slider && slider !== 100" class="mb-1 mt-1">
        <b-col xl="3" lg="3" md="4">
          <h4 class="font-weight-bolder">{{ $t("label_share_of_invoice") }}</h4>
        </b-col>
        <b-col>
          <h4>{{ slider }}%</h4>
        </b-col>
      </b-row>

      <!-- Notification Section -->
      <b-row class="mt-4">
        <h5 v-if="slider && slider !== 100" class="col-md-12 text-secondary" >
          {{ $t("notification_option_executed") }}
        </h5>
        <h5 v-else class="col-md-12 text-secondary">
          {{ $t("notification_option_bought") }}
        </h5>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ["invoiceData", "slider"],
  data() {
    return {};
  }
};
</script>

<style scoped>

#tooltipOvertake {
  color: rgb(34 47 40 / 60%);
  margin-left: 5px;
  margin-bottom: 5px;
}

</style>

